import { useQuery } from "react-query";

import {
  makeSimpleGetRequest,
  makeSimplePatchRequest,
  makeSimplePostRequest,
} from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import { ListingCustomCashflow, ListingCustomCashflowPayload } from "./types";

const LISTING_CUSTOM_CASHFLOWS_URL = `${ORDERBOOK_URL}/listing-custom-cashflows/`;

const getListingCustomCashflows = async (
  listingId: number,
): Promise<ListingCustomCashflow[]> => {
  return await makeSimpleGetRequest<ListingCustomCashflow[]>(
    `${LISTING_CUSTOM_CASHFLOWS_URL}?filter{listing}=${listingId}`,
  );
};

export const useListingCustomCashflows = (listingId: number) => {
  return useQuery<ListingCustomCashflow[]>(
    ["listing-custom-cashflows", listingId],
    () => getListingCustomCashflows(listingId),
    {
      enabled: !!listingId,
    },
  );
};

export const createListingCustomCashflow = async (
  payload: ListingCustomCashflowPayload,
): Promise<ListingCustomCashflow> => {
  return makeSimplePostRequest<ListingCustomCashflow>(
    LISTING_CUSTOM_CASHFLOWS_URL,
    JSON.stringify(payload),
    [201],
  );
};

export const updateListingCustomCashflow = async (
  id: number,
  payload: ListingCustomCashflowPayload,
): Promise<ListingCustomCashflow> => {
  return makeSimplePatchRequest<ListingCustomCashflow>(
    `${LISTING_CUSTOM_CASHFLOWS_URL}${id}/`,
    JSON.stringify(payload),
    [200],
  );
};
